<section class="final-cta" id="demo">
  <div class="cta-content">
    <h2>Prêt à élargir votre mission ?</h2>
    <p class="cta-highlight">Générez 45 000€ de revenus additionnels dès la première année</p>
    <p>Transformez vos données comptables en bilans patrimoniaux professionnels dès la première année et proposez du conseil à forte valeur ajoutée.</p>
    <div class="cta-buttons">
      <a  class="btn-gold" [routerLink]="'/login'"><span>Démarrer l'essai gratuit</span></a>
      <a  class="btn-outline" (click)="openDemoPopupEvent.emit()"><span>Demander une démo</span></a>
    </div>
  </div>
</section>

